module.exports = __webpack_public_path__ + "img/gift-icon.0fdc720.jpg";